// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3dypL","description":"PatientConsentPreview_description__25vfB"};